import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import TextError from "@/components/TextError";
import useStore from "../../store/useStore";
import { ICONS } from "@/assets";
import dayjs from "dayjs";
import { message } from "antd";

const LoginPage = () => {
  const { login } = useStore();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const date = dayjs(); // Get current date
  const getYearName = date.format("YYYY");

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const API_BASE_URL = import.meta.env.VITE_BASE_URL;

      // const response = await fetch("http://217.196.49.162:3000/api/user/login", {
      const response = await fetch(`${API_BASE_URL}/api/user/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: data.username,
          password: data.password,
        }),
      });

      const result = await response.json();
      // if (response.ok) {
      //     message.success("Login Berhasil");
      //     login(); // tetap gunakan useStore() jika perlu state global
      //     localStorage.setItem("username", data.username); // ✅ simpan username
      //     localStorage.setItem("user", JSON.stringify(result)); // optional
      //     navigate("/dashboard");
      //   }

      // console.log("ini result login", result)
      if (response.ok) {
        message.success("Login Berhasil");
        login(); // kamu bisa modifikasi agar menyimpan token atau user detail
        
        localStorage.setItem("username", data.username); // ✅ simpan username
        localStorage.setItem("namanya", result.data.user.name); // ✅ simpan username
        localStorage.setItem("rolenya", result.data.user.role); // ✅ simpan username
        localStorage.setItem("cabangnya", result.data.user.cabang); // ✅ simpan username
        localStorage.setItem("user", JSON.stringify(result)); // simpan jika perlu
        navigate("/dashboard");
      } else {
        message.error(result.message || "Login gagal");
      }
    } catch (error) {
      console.error("Login error:", error);
      message.error("Terjadi kesalahan saat login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid md:grid-cols-2 h-screen">
      <div className="bg-[#85193C] hidden md:flex flex-col gap-14 justify-center p-20 max-h-screen ">
        <h1 className="text-white font-bold text-4xl leading-tight lg:text-5xl lg:leading-tight xl:text-6xl xl:leading-tight">
          Manage <br /> Your{" "}
          <span className="text-[#F6B17A]">Loan Applications</span>
        </h1>
        <div>
          <img src={ICONS.FaTeamCollab} alt="img-login" />
        </div>
      </div>

      <div className="flex flex-col justify-center items-center max-h-screen">
        <h1 className="text-primary font-bold text-4xl leading-tight mb-14 text-center md:hidden">
          Management <br /> Your{" "}
          <span className="text-[#F6B17A]">Financial</span>
        </h1>
        <div className="w-2/3 ">
          <h1 className="text-primary font-bold text-4xl mb-2">Gratama Finance Indonesia</h1>
          <p className="text-[#B4B4B3] text-2xl mb-6">Loan Origination System</p>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-4 mb-4">
              <div>
                <label htmlFor="username">Username :</label> <br />
                <input
                  {...register("username", { required: "Username is required" })}
                  className="input"
                  placeholder="Enter your username"
                />
                {errors.username && <TextError errors={errors.username.message} />}
              </div>

              <div>
                <label htmlFor="password">Password :</label> <br />
                <input
                  {...register("password", { required: "Password is required" })}
                  className="input"
                  placeholder="Enter your password"
                  type="password"
                />
                {errors.password && <TextError errors={errors.password.message} />}
              </div>
            </div>

            <button
              type="submit"
              className="w-full bg-primary text-white py-2 rounded-md mt-1"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>

        <p className="fixed bottom-8 text-sm text-primary">
          &#169; {getYearName} all rights reserved
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
